var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 32.9199C0.5 15.2469 14.827 0.919922 32.5 0.919922C50.173 0.919922 64.5 15.2469 64.5 32.9199C64.5 50.5929 50.173 64.9199 32.5 64.9199C14.827 64.9199 0.5 50.5929 0.5 32.9199Z",
    fill: "#00A0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 20.9199C35.981 20.9199 40.011 24.5629 40.62 29.2779L43.321 33.5239C43.499 33.8039 43.463 34.2219 43.051 34.3979L40.7 35.4049V38.9199C40.7 40.2449 39.626 41.3199 38.3 41.3199H35.901L35.9 44.9199H25.1V40.4869C25.1 39.0699 24.576 37.7299 23.607 36.5209C22.288 34.8779 21.5 32.7909 21.5 30.5199C21.5 25.2179 25.798 20.9199 31.1 20.9199ZM30.464 27.8349C29.644 27.0149 28.314 27.0149 27.494 27.8349C26.674 28.6549 26.674 29.9849 27.494 30.8049L31.1 34.4109L34.706 30.8049C35.526 29.9849 35.526 28.6549 34.706 27.8349C33.886 27.0149 32.556 27.0149 31.736 27.8349L31.1 28.4709L30.464 27.8349Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5 0.919922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.71c061262ad78fc7a2a8a1c1218291e8.svg";
export { ForwardRef as ReactComponent };